import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease, delay: i } }),
};

export const MaskLines = ({ lines, className = "", delay = 0.1, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block" variants={lineVariants} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] text-[var(--muted)] flex items-center gap-3 ${className}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-[var(--signal)]" />
    {children}
  </p>
);
